export const APP_STAGE = process.env.REACT_APP_STAGE;
export const SERVICE_URL = process.env.REACT_APP_API_URL;
export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || "";
// DEFINED IN HOURS
export const WEATHER_WIDGET_UPDATE_PERIOD: number = parseFloat(process.env.REACT_APP_WEATHER_UPDATE_PERIOD || "1");
export const LUNCH_API_URL = process.env.REACT_APP_LUNCH_API_URL;